import { render, staticRenderFns } from "./b21.vue?vue&type=template&id=11190973&scoped=true"
import script from "./b21.vue?vue&type=script&lang=js"
export * from "./b21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11190973",
  null
  
)

export default component.exports